import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  InvestmentPurposeAndNatureFormType,
  FormErrors,
  getSchema,
} from '../../forms/investmentPurposeAndNatureForm';

import { FormContent } from './FormContent';

interface Props {
  initialValues?: InvestmentPurposeAndNatureFormType;
  onSubmit: (values: InvestmentPurposeAndNatureFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
}

export const InvestmentPurposeAndNature = ({
  initialValues,
  canGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onGoBack,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.investmentPurposeAndNature.subtitle')}
      title={t('onboarding.investmentPurposeAndNature.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent />
    </FormContainer>
  );
};
